import { render } from "./ResetMFAComponent.vue?vue&type=template&id=42564ab4&scoped=true"
import script from "./ResetMFAComponent.vue?vue&type=script&lang=js"
export * from "./ResetMFAComponent.vue?vue&type=script&lang=js"

import "./ResetMFAComponent.vue?vue&type=style&index=0&id=42564ab4&scoped=true&lang=scss"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42564ab4"]])

export default __exports__